var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"coming-soon ml-2",attrs:{"fluid":""}},[_c('p',[_c('v-icon',[_vm._v("mdi-alert-circle-outline")]),_vm._v(" EM BREVE ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }